export class Nuts3 {
  code?: string;
  name?: string;
}
